import { useState } from "react";
import {
    reporteComparativoAnual,
    reporteComparativoMensual,
    reporteDeudasPendientes,
    reporteFlujoCaja,
    reporteGastosPorCategoria,
    reporteIngresosPorFuente,
    reporteMetasAhorro,
    reportePresupuestoVsReal,
} from "../api/reporteApi";

export default function useReportes() {
    const [filtros, setFiltros] = useState({ fechaInicio: "", fechaFin: "", idCuenta: "", idCategoria: "" });
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const cargar = async () => {
        setLoading(true);
        try {
            const [
                flujoCaja,
                ingresosFuente,
                gastosCategoria,
                comparativoMensual,
                comparativoAnual,
                presupuestoVsReal,
                deudasPendientes,
                metasAhorro,
            ] = await Promise.all([
                reporteFlujoCaja(filtros),
                reporteIngresosPorFuente(filtros),
                reporteGastosPorCategoria(filtros),
                reporteComparativoMensual(filtros),
                reporteComparativoAnual(filtros),
                reportePresupuestoVsReal(filtros),
                reporteDeudasPendientes(),
                reporteMetasAhorro(),
            ]);

            setData({
                flujoCaja,
                ingresosFuente,
                gastosCategoria,
                comparativoMensual,
                comparativoAnual,
                presupuestoVsReal,
                deudasPendientes,
                metasAhorro,
            });
        } finally {
            setLoading(false);
        }
    };

    return { filtros, setFiltros, data, loading, cargar };
}